// Library templates use {tokens}; partners edit friendly [Placeholders].
const TOKENS = [
  ["{my_name}", "[Your Name]"], ["{shop_name}", "[Your Business]"], ["{phone}", "[Your Phone]"],
  ["{email}", "[Your Email]"], ["{website}", "[Your Website]"], ["{bike_path}", "[Bike Path]"],
  ["{velopaths_url}", "[Velopaths Website]"],
];

export const PLACEHOLDERS = ["[Business Name]", "[Contact Name]", "[Bike Path]", "[Your Name]", "[Your Business]", "[Your Phone]", "[Your Email]", "[Velopaths Website]"];

export const toFriendly = (text = "") => TOKENS.reduce((t, [a, b]) => t.replaceAll(a, b), text);

export const fillTemplate = (text, v, script) => {
  const map = {
    "[Your Name]": v.my_name, "[Your Business]": v.shop_name, "[Your Phone]": v.phone, "[Your Email]": v.email,
    "[Your Website]": v.website, "[Bike Path]": v.bike_path, "[Velopaths Website]": v.velopaths_url, "[Business Name]": v.business,
  };
  let out = toFriendly(text).replace(/Hi \[Contact Name\],/g, v.contact ? `Hi ${v.contact},` : "Hi there,")
    .replaceAll("[Contact Name]", v.contact || (script ? "the owner or manager" : "there"));
  Object.entries(map).forEach(([k, val]) => { if (val) out = out.replaceAll(k, val); });
  ["[Your Business]", "[Your Email]", "[Your Website]"].forEach((k) => { out = out.replace(new RegExp(`^${k.replace(/[[\]]/g, "\\$&")}\\n`, "gm"), ""); });
  return out.replace(/\n{3,}/g, "\n\n");
};
